/* One shared campaign clock; no purchase/add_to_cart events are emitted here. */
(() => {
  'use strict';
  const node = document.getElementById('fb-campaign-config');
  if (!node) return;
  let config; try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const start = Date.parse(config.start);
  const end = Date.parse(config.end);
  const enabled = config.enabled === true && Number.isFinite(start) && Number.isFinite(end) && end > start;
  const active = enabled && Date.now() >= start && Date.now() < end;
  const clockNodes = new Set();
  let interval = null;
  const navNodes = new WeakSet();
  let cartClockEventsBound = false;
  let cartClockResizeTimer = 0;
  function positionCartCampaignClock() {
    const clock = document.querySelector('.fb-clearance-cart[data-fb-campaign]');
    const anchor = document.querySelector('[data-fb-clearance-cart-anchor]');
    if (!clock || !anchor) return;
    if (matchMedia('(max-width: 749px)').matches) {
      const items = document.querySelector('#cart .cart__items');
      if (!items) return;
      const title = items.querySelector('.js-cart-title');
      if (title && title.parentNode === items) title.insertAdjacentElement('afterend',clock);
      else if (items.firstElementChild !== clock) items.insertBefore(clock,items.firstChild);
      clock.classList.add('fb-clearance-cart--mobile-top');
    } else {
      anchor.insertAdjacentElement('afterend',clock);
      clock.classList.remove('fb-clearance-cart--mobile-top');
    }
  }
  function setupCartCampaignClock() {
    positionCartCampaignClock();
    if (cartClockEventsBound) return;
    cartClockEventsBound = true;
    const schedule = () => {
      clearTimeout(cartClockResizeTimer);
      cartClockResizeTimer = setTimeout(positionCartCampaignClock,40);
    };
    addEventListener('resize',schedule,{passive:true});
    addEventListener('pageshow',schedule,{passive:true});
    ['cart:updated','cart:refresh','cart:update','cart:change','theme:cart:change','product:added','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
    document.addEventListener('change',event => {
      if (event.target?.closest('input[name="updates[]"], [data-quantity-input], .quantity__input')) schedule();
    });
    document.addEventListener('click',event => {
      if (event.target?.closest('[data-fb-cart-remove], a[href*="/cart/change"], button[name="update"]')) {
        setTimeout(positionCartCampaignClock,100);
        setTimeout(positionCartCampaignClock,400);
      }
    });
  }
  function setupSubnav(scope) {
    scope.querySelectorAll('[data-fb-subnav-wrap]').forEach(wrap => {
      if (navNodes.has(wrap)) return;
      const nav = wrap.querySelector('[data-fb-subnav]');
      const next = wrap.querySelector('[data-fb-subnav-next]');
      const hint = wrap.parentElement.querySelector('[data-fb-subnav-hint]');
      if (!nav || !next) return;
      navNodes.add(wrap);
      const update = () => {
        const overflow = nav.scrollWidth > nav.clientWidth + 2;
        const atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 3;
        next.hidden = !overflow || atEnd;
        if (hint) {
          hint.hidden = !overflow;
          hint.textContent = atEnd ? 'Görgess balra a korábbi kategóriákért ←' : 'Húzd vagy görgesd jobbra a további kategóriákért →';
        }
      };
      next.addEventListener('click', () => nav.scrollBy({left:Math.max(150,nav.clientWidth * .7),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
      nav.addEventListener('scroll',update,{passive:true});
      if (window.ResizeObserver) new ResizeObserver(update).observe(nav);
      else window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  const api = {
    active,
    money(cents, moneyFormat) {
      const currency = window.Shopify?.currency?.active || config.currency;
      // Intl uses the active Shopify presentment currency and supports Markets.
      try { return new Intl.NumberFormat(config.locale || 'hu-HU', {style:'currency',currency}).format(Number(cents) / 100); }
      catch (_) { return window.Shopify?.formatMoney ? window.Shopify.formatMoney(cents, moneyFormat || config.moneyFormat) : (Number(cents)/100).toFixed(2) + ' ' + currency; }
    },
    scan(scope = document) {
      if (scope.matches?.('[data-fb-clock]')) clockNodes.add(scope);
      scope.querySelectorAll('[data-fb-clock]').forEach(el => clockNodes.add(el));
      setupSubnav(scope);
      setupCartCampaignClock();
      tick();
      if (enabled && Date.now() < end && !interval) interval = window.setInterval(tick, 1000);
    }
  };
  window.FansBrandsCampaign = api;
  document.documentElement.dataset.fbCurrency = config.currency;
  function tick() {
    const now = Date.now();
    api.active = enabled && now >= start && now < end;
    // The presentation and discount restrictions remain after the clock expires.
    document.documentElement.dataset.fbClearance = String(enabled && now >= start);
    const remaining = Math.max(0, Math.floor((end - now) / 1000));
    const values = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    clockNodes.forEach(el => {
      if (!el.isConnected) { clockNodes.delete(el); return; }
      el.hidden = !api.active;
      const wrapper = el.closest('.fb-campaign-banner__clock, .fb-editorial__clock, .fb-clearance-cart');
      if (wrapper) wrapper.hidden = !api.active;
      const editorial = el.closest('.fb-editorial');
      if (editorial) editorial.classList.toggle('fb-editorial--without-clock', !api.active);
      if (!api.active) return;
      Object.entries(values).forEach(([unit,value]) => { const digit=el.querySelector('[data-unit="'+unit+'"]'); if(digit && digit.textContent!==String(value).padStart(2,'0'))digit.textContent=String(value).padStart(2,'0'); });
    });
    if ((!enabled || now >= end) && interval) { clearInterval(interval); interval = null; }
  }

  const boot = () => {
    api.scan();
    // Quick Add and Shopify section responses may arrive after initial load.
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(added => {
        if (added.nodeType === 1 && (added.matches('[data-fb-clock]') || added.querySelector('[data-fb-clock], [data-fb-subnav-wrap]'))) {
          if (added.matches('[data-fb-clock]')) clockNodes.add(added);
          api.scan(added);
        }
      }));
    });
    observer.observe(document.body,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load',event=>api.scan(event.target));
    document.addEventListener('visibilitychange',()=>{ if(!document.hidden)tick(); });
    addEventListener('pageshow',()=>api.scan());
    // Optional, distinct campaign engagement events. Existing ecommerce tracking is untouched.
    document.addEventListener('click',event=>{
      const link=event.target.closest('[data-fb-campaign-event]');
      if(link && api.active && Array.isArray(window.dataLayer)) window.dataLayer.push({event:link.dataset.fbCampaignEvent,link_url:link.getAttribute('href'),link_text:link.textContent.trim()});
    });
    document.addEventListener('toggle',event=>{
      const details=event.target;
      if(details.matches && details.matches('.fb-ux-accordion--vip') && details.open && api.active && Array.isArray(window.dataLayer)) window.dataLayer.push({event:'clearance_vip_info_open'});
    },true);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
